import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f720230"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MEntradaNumerica p-input-filled field",
  "data-testid": "MEntradaNumerica"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}

import { computed, Ref, withDefaults } from "vue"
  import InputNumber from "primevue/inputnumber"
  import { Nullable } from "primevue/ts-helpers"

  interface Props {
    id?: string
    combinado?: boolean
    rotulo?: string
    modelValue: Nullable<number>
    modo?: "decimal" | "currency"
    minFracaoDigitos?: number
    min?: number
    max?: number
    desativado?: boolean
    sufixo?: string
    fatorIncremento?: number
    maxFracaoDigitos?: number
    idParaTestes?: string
    mensagemDeErro?: string | Ref<string>
    obrigatorio?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MEntradaNumerica',
  props: {
    id: null,
    combinado: { type: Boolean },
    rotulo: null,
    modelValue: null,
    modo: null,
    minFracaoDigitos: null,
    min: null,
    max: null,
    desativado: { type: Boolean },
    sufixo: null,
    fatorIncremento: null,
    maxFracaoDigitos: null,
    idParaTestes: { default: "MEntradaNumerica__Entrada" },
    mensagemDeErro: null,
    obrigatorio: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: Nullable<number>): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { id?: string, combinado?: boolean, rotulo?: string, modelValue: Nullable<number>, modo?: "decimal" | "currency", minFracaoDigitos?: number, min?: number, max?: number, desativado?: boolean, sufixo?: string, fatorIncremento?: number, maxFracaoDigitos?: number, idParaTestes: string, mensagemDeErro?: string | Ref<string>, obrigatorio?: boolean }

  

  
  const emitirModel = computed({
    get(): Nullable<number> {
      return props.modelValue
    },
    set(value: Nullable<number>) {
      emitir("update:modelValue", value)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "MEntradaNumerica__Rotulo",
      for: __props.id
    }, [
      _createElementVNode("span", null, _toDisplayString(__props.rotulo), 1),
      (__props.obrigatorio)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(_unref(InputNumber), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      id: __props.id,
      "aria-describedby": "input-help",
      class: _normalizeClass(["MEntradaNumerica__Entrada", { 'p-invalid': __props.mensagemDeErro }]),
      "data-testid": __props.idParaTestes,
      disabled: __props.desativado,
      format: "",
      max: __props.max,
      "max-fraction-digits": __props.maxFracaoDigitos,
      min: __props.min,
      "min-fraction-digits": __props.minFracaoDigitos,
      mode: __props.modo,
      step: __props.fatorIncremento,
      suffix: __props.sufixo,
      "use-grouping": __props.combinado
    }, null, 8, ["modelValue", "id", "class", "data-testid", "disabled", "max", "max-fraction-digits", "min", "min-fraction-digits", "mode", "step", "suffix", "use-grouping"]),
    _withDirectives(_createElementVNode("small", {
      id: "input-help",
      class: "p-error",
      "data-testid": "input-error"
    }, _toDisplayString(__props.mensagemDeErro), 513), [
      [_vShow, __props.mensagemDeErro]
    ])
  ]))
}
}

})